import { render, staticRenderFns } from "./addVendorBasicDetailComponent.vue?vue&type=template&id=3303c87c&"
import script from "./addVendorBasicDetailComponent.vue?vue&type=script&lang=js&"
export * from "./addVendorBasicDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports